// extracted by mini-css-extract-plugin
export default {"avatar":"ChatMessageReactionCountAvatars_avatar__OYo0S"};